import React, { useEffect, useState } from "react";

import NavLinkbar from "~/components/navLinkBar";
import InfoSection from "~/components/InfoSection/InfoSection";

import * as St from "./styles";
import { homeObjOne } from "./data";

const DeepLink = () => {
  const [platform, setPlatform] = useState(null);

  /**
   * @description Funcao para validar se o app esta instalado via deep link, caso o app nao esteja instalado, redireciona para o site.
   * Caso o app esteja instalado, o app sera aberto.
   */
  const validateAppInstallation = (deeplink, storeLink) => {
    window.location = deeplink;
    let fallbackLink = storeLink;
    // setTimeout ainda executa depois que o aplicativo é aberto, então a página atual navegará para o link de fallback
    // para evitar isso, eu uso a função document.hasFocus para verificar
    setTimeout(function () {
      // se o aplicativo for aberto, o documento não estará focado
      // então se o aplicativo não estiver instalado, o documento estará focado
      if (document.hasFocus()) {
        window.open(fallbackLink, '_blank');
      }
    }, 1000);
  };

  /**
   * @description Função que verifica o sistema operacional e redireciona para a loja correspondente
   * Caso o sistema não seja Android ou iOS, exibe uma mensagem na tela para o usuário
   */
  const redirectToStore = async () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    console.log(userAgent);

    // Verifica se é iOS
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setPlatform("iPhone");
      validateAppInstallation(
        "novaeracard://proposalInfo",
        "https://apps.apple.com/br/app/teucard-do-teu-jeito/id1562686964"
      );
    }
    else if (/android/i.test(userAgent)) {
      setPlatform("Android");
      validateAppInstallation(
        "novaeracard://novaeracard/proposalInfo",
        "https://play.google.com/store/apps/details?id=com.novaera"
      );
    }
    else {
      setPlatform("Windows");
    }
  };

  useEffect(() => {
    redirectToStore();
  }, []);

  return (
    <St.Container>
      <NavLinkbar />
      <InfoSection platform={platform} {...homeObjOne} />
    </St.Container>
  );
};

export default DeepLink;
